import Cookies from 'universal-cookie'
import { init as initClient } from './client'

export const init = () => initClient(new Cookies())
